export default __webpack_public_path__ + "static/media/propagator-ss.422f54ba.png";